import { render, staticRenderFns } from "./ReturnItemsCart.vue?vue&type=template&id=059acd62&"
import script from "./ReturnItemsCart.vue?vue&type=script&lang=js&"
export * from "./ReturnItemsCart.vue?vue&type=script&lang=js&"
import style0 from "./ReturnItemsCart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports